import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { CollectionPage } from './pages/CollectionPage';
import { ApparelSubcategoriesPage } from './pages/ApparelSubcategoriesPage';
import { CartPage } from './pages/CartPage';
import { CartProvider } from './context/CartContext';
export function App() {
  return <CartProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/collection/apparel" element={<ApparelSubcategoriesPage data-id="element-6" />} data-id="element-5" />
          <Route path="/collection/:categoryId" element={<CollectionPage data-id="element-8" />} data-id="element-7" />
          <Route path="/cart" element={<CartPage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </Router>
    </CartProvider>;
}